import * as config from './config';

export default (key) => config.app[key];
